module.exports = __webpack_public_path__ + "static/media/paper.618510a4.jpg";